import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import EmergencyCallButton from './components/EmergencyCallButton';
import Home from './pages/Home';
import Services from './pages/Services';
import RepairBreakdown from './pages/RepairBreakdown';
import ServiceMaintenance from './pages/ServiceMaintenance';
import Commercial from './pages/Commercial';
import About from './pages/About';
import Areas from './pages/Areas';
import Contact from './pages/Contact';
import AIEstimator from './pages/AIEstimator';
import QuoteView from './pages/QuoteView';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminServiceSheet from './pages/AdminServiceSheet';
import AdminBossUsers from './pages/AdminBossUsers';
import { AuthProvider, ProtectedRoute } from './lib/AuthContext';
import { Toaster } from './components/ui/toaster';

function PublicChrome({ children }) {
  const location = useLocation();
  // Admin routes are intentionally hidden from the public site (no header, no footer, no marketing CTA).
  const isAdmin = location.pathname.startsWith('/admin');
  return (
    <>
      {!isAdmin && <Header />}
      {children}
      {!isAdmin && <Footer />}
      {!isAdmin && <EmergencyCallButton />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-[#0d1829] text-white">
        <BrowserRouter>
          <AuthProvider>
            <PublicChrome>
              <Routes>
                <Route path="/" element={<Home />} />
                {/* New service categories — short, SEO-friendly URLs */}
                <Route path="/installation" element={<Services />} />
                <Route path="/repair" element={<RepairBreakdown />} />
                <Route path="/service" element={<ServiceMaintenance />} />
                {/* Legacy redirects — preserve any inbound links / Google ads */}
                <Route path="/services" element={<Navigate to="/installation" replace />} />
                <Route path="/repair-breakdown" element={<Navigate to="/repair" replace />} />
                <Route path="/service-maintenance" element={<Navigate to="/service" replace />} />
                <Route path="/commercial" element={<Commercial />} />
                <Route path="/about" element={<About />} />
                <Route path="/areas" element={<Areas />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/ai-estimator" element={<AIEstimator />} />
                <Route path="/q/:quoteId" element={<QuoteView />} />

                {/* Hidden engineer portal */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/service-sheet/new"
                  element={
                    <ProtectedRoute>
                      <AdminServiceSheet />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/service-sheet/:id"
                  element={
                    <ProtectedRoute>
                      <AdminServiceSheet />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/boss-users"
                  element={
                    <ProtectedRoute>
                      <AdminBossUsers />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </PublicChrome>
          </AuthProvider>
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
